import { render, staticRenderFns } from "./ed-tabs-content.vue?vue&type=template&id=0bbf03c6&scoped=true&"
import script from "./ed-tabs-content.ts?vue&type=script&lang=ts&"
export * from "./ed-tabs-content.ts?vue&type=script&lang=ts&"
import style0 from "./ed-tabs-content.scss?vue&type=style&index=0&id=0bbf03c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf03c6",
  null
  
)

export default component.exports